import { parseOptimizationFailure } from '../utils/optimizationFailureParser';

interface OptimizationFailureCardProps {
  errorLog: string;
  className?: string;
}

export default function OptimizationFailureCard({ errorLog, className = '' }: OptimizationFailureCardProps) {
  const parsed = parseOptimizationFailure(errorLog);

  if (!parsed) return null;

  return (
    <div className={`rounded-xl border border-red-200 bg-white shadow-sm overflow-hidden ${className}`}>
      <div className="bg-gradient-to-r from-red-50 to-rose-50 border-b border-red-100 px-4 py-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-1 text-xs font-semibold text-red-700">
            Run non riuscita
          </span>
          {parsed.solverStatus && (
            <span className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700">
              Solver: {parsed.solverStatus}
            </span>
          )}
        </div>
      </div>

      <div className="px-4 py-3 space-y-3 text-sm">
        {parsed.suspectedConstraints.length > 0 && (
          <div>
            <p className="font-semibold text-gray-900 mb-1">Cause probabili</p>
            <ul className="space-y-1.5">
              {parsed.suspectedConstraints.map((item, idx) => (
                <li key={`${item}-${idx}`} className="rounded-md bg-red-50 border border-red-100 px-3 py-2 text-red-900">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}

        {parsed.feasibleRelaxations.length > 0 && (
          <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2">
            <p className="font-semibold text-amber-900 mb-1">Per ottenere una soluzione</p>
            <p className="text-amber-800">
              Valutare l'allentamento di: {parsed.feasibleRelaxations.join(', ')}.
            </p>
          </div>
        )}

        <details className="group">
          <summary className="cursor-pointer list-none text-xs font-medium text-gray-500 hover:text-gray-700">
            <span className="inline-flex items-center gap-1">
              <svg className="h-3.5 w-3.5 transition-transform group-open:rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
              Mostra log tecnico
            </span>
          </summary>
          <pre className="mt-2 max-h-44 overflow-auto whitespace-pre-wrap break-words rounded-md border border-gray-200 bg-gray-900 px-3 py-2 text-xs text-emerald-300 font-mono">
{parsed.raw}
          </pre>
        </details>
      </div>
    </div>
  );
}
